// extracted by mini-css-extract-plugin
export default {"root":"Login_root__PpI8+","logo":"Login_logo__l3Enk","signupForm":"Login_signupForm__BZUgS","title":"Login_title__7aFWC","error":"Login_error__DBgdh"};